import { LockOpenMinusOutlineIcon } from './LockOpenMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A268FC79-9328-4B33-A734-9A4614BB3776
 * name lock-open-minus-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-minus-outline.svg
 * tags
 * - Lock 
 */
export const UnlockedMinusOutlineIcon = LockOpenMinusOutlineIcon;
export default UnlockedMinusOutlineIcon